module.exports = __webpack_public_path__ + "static/media/Perseverance.ac36d619.jpg";